import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-sidebar-footer',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './app-sidebar-footer.component.html'
})
export class AppSidebarFooterComponent { }
